import uniqueId from 'lodash/uniqueId';
import styled from 'styled-components';
import CTA from '../../atoms/CTA';
import Row from '~/grid/Row';
import { CTAIconPosition } from '../../atoms/CTA/CTA.constants';
import { createElement } from 'react';

const margin = 10;

const RowStyled = styled(Row)`
  align-items: center;
  justify-content: ${(props) =>
    props.align === 'CENTER' ? 'center' : 'flex-start'};
  max-width: 100%;
`;

const CtaItem = styled.div`
  margin: ${margin}px;
`;

/**
 * @param {CtaTypes} props
 * @returns {React.ReactElement} The rendered component
 */
const CtaLinks = ({ align, ctas, isBrand }) => (
  <RowStyled align={align} gutter={margin * 2} dataId="cta-links-row">
    {ctas.map((cta) => {
      const { title, text, href, target, icon, skin } = cta;
      return (
        <CtaItem key={uniqueId('cta_')} data-id="cta-links-container">
          {createElement(CTA, {
            dataId: 'cta-links-item',
            isBrand,
            skin,
            title,
            text,
            href,
            target,
            icon,
            iconPos:
              cta.skin === 'TERTIARY'
                ? CTAIconPosition.Before
                : CTAIconPosition.After,
          })}
        </CtaItem>
      );
    })}
  </RowStyled>
);

export default CtaLinks;
